import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography,
  AppBar, Toolbar, Container, Alert, CircularProgress, Avatar, Chip,
} from "@mui/material";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AssignmentIcon from "@mui/icons-material/Assignment";
import {
  infoInscricao, logoutCandidato, candidatoLogado, getCandidato,
} from "../../services/candidatoService";
import CandidatoFicha from "./CandidatoFicha";
import MeusDadosDialog from "./MeusDadosDialog";
import MinhasInscricoesDialog from "./MinhasInscricoesDialog";
import { AuthTabs } from "./CandidatoAuth";

const fmtData = (d) => (d ? new Date(d).toLocaleDateString("pt-BR") : null);

export default function InscricaoPage() {
  const { token } = useParams();
  const [info, setInfo] = useState(undefined);
  const [logado, setLogado] = useState(candidatoLogado());
  const [dadosOpen, setDadosOpen] = useState(false);
  const [inscOpen, setInscOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try { setInfo((await infoInscricao(token)).data); }
      catch { setInfo(null); }
    })();
  }, [token]);

  if (info === undefined)
    return <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}><CircularProgress /></Box>;
  if (info === null)
    return <Box sx={{ maxWidth: 480, mx: "auto", mt: 10, px: 2 }}><Alert severity="error">Inscrição não encontrada ou indisponível.</Alert></Box>;

  const candidato = getCandidato();
  const sair = () => { logoutCandidato(); setLogado(false); };
  const ed = info.Edicao;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="static" elevation={0} sx={{ background: "linear-gradient(135deg, #0f1b3d 0%, #3b5bdb 100%)" }}>
        <Toolbar>
          <Avatar sx={{ bgcolor: "rgba(255,255,255,0.15)", mr: 1.5 }}><VolunteerActivismIcon /></Avatar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ lineHeight: 1.1 }}>Inscrição</Typography>
            <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.75)" }}>{ed.Nome}</Typography>
          </Box>
          {logado && (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Typography variant="body2" sx={{ display: { xs: "none", sm: "block" } }}>{candidato?.Nome}</Typography>
              <Button color="inherit" variant="outlined" size="small" startIcon={<AssignmentIcon />} onClick={() => setInscOpen(true)} sx={{ borderColor: "rgba(255,255,255,0.5)" }}>Minhas inscrições</Button>
              <Button color="inherit" variant="outlined" size="small" onClick={() => setDadosOpen(true)} sx={{ borderColor: "rgba(255,255,255,0.5)" }}>Meus dados</Button>
              <Button color="inherit" variant="outlined" size="small" onClick={sair} sx={{ borderColor: "rgba(255,255,255,0.5)" }}>Sair</Button>
            </Stack>
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 3 }}>
        <Paper sx={{ p: 2.5, mb: 3, display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
          <EventAvailableIcon color="primary" sx={{ fontSize: 34 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">{ed.Nome}</Typography>
            <Typography variant="body2" color="text.secondary">
              {ed.DataInicio || ed.DataFim
                ? `Período: ${fmtData(ed.DataInicio) || "—"} a ${fmtData(ed.DataFim) || "—"}`
                : "Inscrições abertas"}
            </Typography>
          </Box>
          <Chip label={ed.Aberta ? "Inscrições abertas" : "Encerrada"} color={ed.Aberta ? "success" : "default"} />
        </Paper>

        {!ed.Aberta && <Alert severity="warning" sx={{ mb: 2 }}>O período de inscrição desta edição está encerrado.</Alert>}

        {!logado ? (
          <AuthTabs onOk={() => setLogado(true)} />
        ) : (
          <CandidatoFicha token={token} perguntas={info.Perguntas} aberta={ed.Aberta} />
        )}
      </Container>

      {logado && <MeusDadosDialog open={dadosOpen} onClose={() => setDadosOpen(false)} />}
      {logado && <MinhasInscricoesDialog open={inscOpen} onClose={() => setInscOpen(false)} tokenAtual={token} />}
    </Box>
  );
}
